import { BRANDS, VALIDATIONS } from "../../../../configs";

const getMinAdults = (brand, isSmallGroupSov) => {

  if (isSmallGroupSov) {
    return VALIDATIONS.SOV_SMALL_GROUP.MIN_ADULTS;
  }
  if (brand === BRANDS.SOV) {
    return VALIDATIONS.SOV_PACKAGES.MIN_ADULTS;
  }
  return VALIDATIONS.PACKAGES.MIN_ADULTS;
};

const getMaxAdults = (brand, isSmallGroupSov) => {

  if (isSmallGroupSov) {
    return VALIDATIONS.SOV_SMALL_GROUP.MAX_ADULTS;
  }
  if (brand === BRANDS.SOV) {
    return VALIDATIONS.SOV_PACKAGES.MAX_ADULTS;
  }
  return VALIDATIONS.PACKAGES.MAX_ADULTS;
};

const getMinChildren = brand => {
  if (brand === BRANDS.SOV) {
      return VALIDATIONS.SOV_PACKAGES.MIN_CHILDREN;
  }
  return VALIDATIONS.PACKAGES.MIN_CHILDREN;
}

const getMaxChildren = brand => {
  if (brand === BRANDS.SOV) {
      return VALIDATIONS.SOV_PACKAGES.MAX_CHILDREN;
  }
  return VALIDATIONS.PACKAGES.MAX_CHILDREN;
}

const getMinRoom = (brand, isSmallGroupSov) => {
  if (isSmallGroupSov) {
      return VALIDATIONS.SOV_SMALL_GROUP.MIN_ROOMS;
  }
  if (brand === BRANDS.SOV) {
      return VALIDATIONS.SOV_PACKAGES.MIN_ROOMS;
}
return VALIDATIONS.PACKAGES.MIN_ROOMS;
}

const getMaxRoom = (brand, isSmallGroupSov) => {
  if (isSmallGroupSov) {
      return VALIDATIONS.SOV_SMALL_GROUP.MAX_ROOMS;
  }
  if (brand === BRANDS.SOV) {
      return VALIDATIONS.SOV_PACKAGES.MAX_ROOMS;
  }
  return VALIDATIONS.PACKAGES.MAX_ROOMS;
}

  // eslint-disable-next-line import/prefer-default-export
  export { getMinAdults, getMaxAdults, getMinChildren, getMaxChildren, getMinRoom, getMaxRoom}